import { ILoggedUser, UserRoles } from 'types';
import jwt_decode from 'jwt-decode';

export const useRoleAccess = (permittedRoles: UserRoles[]) => {
	let hasAccess = false;
	const accessToken = localStorage.getItem('accessToken');
	if (accessToken) {
		const dataFromJwtToken = jwt_decode<ILoggedUser>(accessToken);
		hasAccess = permittedRoles.includes(dataFromJwtToken.role as UserRoles);
	}
	return hasAccess;
};
